import * as React from 'react';
import Svg, { Path } from 'react-native-svg';
const CameraFilled = (props) => (<Svg viewBox="0 0 11 10" width={10} height={10} {...props}>
    <Path fillRule="evenodd" clipRule="evenodd" d="M9.246 9.688H1.754A1.249 1.249 0 0 1 .5 8.438V2.812a1.25 1.25 0 0 1 1.244-1.25h1L3.7.602c.194-.18.447-.282.71-.286h2.18c.264.006.517.109.71.29l.96.96h1a1.25 1.25 0 0 1 1.24 1.246v5.632a1.25 1.25 0 0 1-1.254 1.244ZM5.5 2.812a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5Zm0 3.751a1.25 1.25 0 1 0 .001-2.501A1.25 1.25 0 0 0 5.5 6.563Z" fill={props?.fill ?? '#393360'}/>
  </Svg>);
export default CameraFilled;
